module.exports = __webpack_public_path__ + "media/images/crypto-currencies/bitcoinglod-00f72dfef0d592f64184e02309380ce6.svg";